<!-- eslint-disable -->
<template>
	<div class="bg-white" :class="orientation == 'desktop' ? 'position-relative m-auto vh-100' : ''"
		:style="orientation == 'desktop' ? 'max-width:460px;' : ''"
	>
		<PaxelLoader
			:loading="loading"
			style="
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);"
		>
		</PaxelLoader>
		<div v-if="showHeader" class="p-4" @click="backToOrder()">
			<img
				v-if="showCancelIcon"
				height="30"
				width="30"
				src="@/assets/images/ic_close-1.svg"
				alt="close"
			/>
			<svg v-else class="" viewBox="0 0 24 24" style="fill: #5e51a1;width: 1.5rem;height: 1.5rem;">
				<path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
			</svg>
		</div>
		<CancelRent v-if="!loading && $route.query.act === 'cancel_success'" />
		<StopRent v-if="!loading && $route.query.act === 'stop_success'" />
		<StopRentCountDown v-if="!loading && $route.query.act === 'stop_count'" />
		<OpenLocker v-if="!loading && $route.query.act === 'open_locker'" />
	</div>
</template>
<script>
/* eslint-disable */
import { isMobile } from "mobile-device-detect";
import PaxelLoader from "@/components/PaxelLoader.vue";
import CancelRent from "./view_action/CancelRent.vue";
import StopRent from "./view_action/StopRent.vue";
import StopRentCountDown from "./view_action/StopRentCountDown.vue";
import OpenLocker from "./view_action/OpenLocker.vue";
import LocalStorage from '@/services/localstorage';
export default {
	components: {
		PaxelLoader,
		CancelRent,
		StopRent,
		StopRentCountDown,
		OpenLocker
	},
	data() {
		return {
			loading: false,
			orientation: "desktop"
		};
	},
	computed: {
		showCancelIcon() {
			if (this.$route.query.act === "cancel_success" || this.$route.query.act === "stop_success") {
				return true;
			}
			return false;
		},
		showHeader() {
			if (this.$route.query.act === "stop_count") {
				return false;
			}
			return true;
		}
	},
	async beforeMount() {
		let settings = this.$store.getters.getSettings;
		if (!settings) {
			this.loading = true;

			try {
				await this.$store.dispatch("getSettings");
			} catch (err) {
				console.log({ err });
			} finally {
				this.loading = false;
			}
		}
		if (isMobile) {
			this.orientation = "mobile";
		}
	},
	methods: {
		backToOrder(){
			if(this.$route.query.act == 'stop_success'){
				let url  = window.location.origin+"/order-status?orderid="+LocalStorage.getOrderId()+"&token="+LocalStorage.getUserToken()
				window.location.replace(url)
			}else{
				this.$router.go(-1);
			}
		}
	}
};
</script>
